import { Icon } from "@iconify/react/dist/iconify.js";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../utils/apiClient";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setPermissions } from "../../redux/slice/permissions";
import { setProfileInfo } from "../../redux/slice/getProfileInfo";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Auto-fill credentials if "Remember Me" was checked
  useEffect(() => {
    const remembered = localStorage.getItem("rememberMe");
    if (remembered === "true") {
      const rememberedEmail = localStorage.getItem("rememberEmail");
      const rememberedPassword = localStorage.getItem("rememberPassword");
      if (rememberedEmail) setEmail(rememberedEmail);
      if (rememberedPassword) setPassword(rememberedPassword);
      setRemember(true);
    }
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await api.post("/login", { email, password });
      if (response.data.status) {
        const { token, data } = response.data;
        const { id, role_id, name, icon, email } = data;

        const perms = (data.permissions || []).map(p => p.name); // safe

        // store token
        localStorage.setItem("token", token);

        dispatch(setPermissions(perms));
        dispatch(setProfileInfo({ id, role_id, name, icon, email }));

        toast.success("Login Successfully");
        navigate("/dashboard", { replace: true });
      } else {
        setError(response.data.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError(err.response?.data?.message || "Server not reachable");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="auth bg-base d-flex flex-wrap " >
      <div className="auth-right py-32 px-24 d-flex flex-column align-items-center justify-content-center w-100">
        <div className="max-w-464-px mx-auto w-100">
          <div className="center-all" >
            <div className="logo-wrapper">
              <img src="/assets/images/app_logo.webp" alt="Logo" />
            </div>
            <h4 className="mb-12">Sign In to your Account</h4>
            <p className="mb-32 text-secondary-light text-lg">
              Welcome back! please enter your detail
            </p>
          </div>

          {error && <p className="text-danger mb-16">{error}</p>}

          <form onSubmit={handleSubmit}>
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                name="email"
                className="form-control h-56-px bg-neutral-50 radius-12"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  id="your-password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <span
                className="toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>

            <div className="">
              <div className="d-flex justify-content-between gap-2">
                <div className="form-check style-check d-flex align-items-center">
                  <input
                    className="form-check-input border border-neutral-300"
                    type="checkbox"
                    checked={remember}
                    onChange={() => setRemember(!remember)}
                    id="remember"
                  />
                  <label className="form-check-label" htmlFor="remember">
                    Remember me
                  </label>
                </div>
                <Link to="/forgot-password" className="text-primary-600 fw-medium">
                  Forgot Password?
                </Link>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              disabled={loading}
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default LoginPage;